var _rect, _path, _path2, _rect2, _path3, _path4, _path5, _ellipse, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
import { forwardRef } from "react";
var SvgEnvelopeWithShadow = function SvgEnvelopeWithShadow(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 87,
    height: 84,
    viewBox: "0 0 87 84",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 15.3252,
    y: 25.3862,
    width: 58.4348,
    height: 40.0696,
    rx: 6,
    transform: "rotate(6 15.3252 25.3862)",
    fill: "#C5CEFF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M67.8971 41.7887L45.1626 55.2303C42.8856 56.5766 39.9956 56.2729 38.0483 54.4827L18.6042 36.6079C14.3484 32.6956 17.5429 25.6193 23.292 26.2236L65.4706 30.6568C71.2197 31.261 72.8732 38.8466 67.8971 41.7887Z",
    fill: "#8C9EFF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.8568 26.8095L42.6649 7.68812C45.1809 5.82401 48.7073 6.20816 50.7629 8.57027L71.648 32.5697L45.8546 60.3522C43.1332 63.2835 38.3597 62.7816 36.3075 59.3484L16.8568 26.8095Z",
    fill: "#8C9EFF"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 22.6318,
    y: 15.2422,
    width: 46.7478,
    height: 47.5826,
    rx: 6,
    transform: "rotate(6 22.6318 15.2422)",
    fill: "url(#paint0_linear_1527_1083)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M32.9406 49.8582L17.6064 35.6201L15.155 58.9438L32.9406 49.8582Z",
    fill: "#C5CEFF"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M51.1594 51.8172L69.0664 41.1567L66.6283 64.354L51.1594 51.8172Z",
    fill: "#C5CEFF"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M16.7394 54.9313L39.6824 41.512C41.966 40.1763 44.855 40.494 46.7939 42.294L66.0231 60.1457C70.2487 64.0687 67.048 71.1128 61.3137 70.5101L19.1415 66.0776C13.3781 65.4718 11.7371 57.8571 16.7394 54.9313Z",
    fill: "url(#paint1_linear_1527_1083)"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    opacity: 0.6,
    cx: 29.2174,
    cy: 2,
    rx: 29.2174,
    ry: 2,
    transform: "matrix(-1 8.74228e-08 8.74227e-08 1 72.7178 80)",
    fill: "url(#paint2_linear_1527_1083)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1527_1083",
    x1: 46.2851,
    y1: 45.321,
    x2: 46.8649,
    y2: 32.7195,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ECEFF1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1527_1083",
    x1: -7.72221,
    y1: -3.70108,
    x2: 70.6253,
    y2: 76.1673,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8C9EFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C5CEFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_1527_1083",
    x1: 65.0751,
    y1: 0.266667,
    x2: 62.88,
    y2: 14.6002,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8C9EFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EEF8FF",
    stopOpacity: 0
  })))));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgEnvelopeWithShadow);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "envelope-with-shadow.93113e740415f0a6b71c36aa47cc26e9.svg";